/**
 * ログイン情報（mst002）テーブル操作用メソッド 
 */

// メモった！、キニッタ！共通メソッド
import * as GVar from '@/components/00/Var00';
import * as Tools from '@/components/00/Tools';         // 共通ツール
import * as GFunc from '@/components/00/Common00';    // 共通メソッド
import * as Mst001 from '@/components/00/db/Mst001'; 

/**
 * ログイン情報(Mst002)
 */
export class Mst002DTO
{
   sys_cd = "";      // システムコード
   tmplt_cd = "";  // テンプレートコード
   eml = "";            // メールアドレス
   pwd = "";            // パスワード
   auto_login = "";  // オートログイン
   upd_ts = "";          // 更新日時

   constructor (sys_cd: string, tmplt_cd: string, eml: string, pwd: string, auto_login: string, upd_ts: string)
   {
       this.sys_cd = sys_cd;      // システムコード
       this.tmplt_cd = tmplt_cd;  // テンプレートコード
       this.eml = eml;            // メールアドレス
       this.pwd = pwd;            // パスワード
       this.auto_login = auto_login;  // オートログイン
       this.upd_ts = upd_ts;          // 更新日時
   }
}

/**
 * mst002テーブル新規作成
 */
export const create = async function()
{
    const tabaleId = "mst002";
    if ( GFunc.isDebugEnabled() ) {console.log(tabaleId+" create()");}
    try
    {
        // テーブル新規作成
        const resp = await GVar.db!.run("CREATE TABLE IF NOT EXISTS mst002 (sys_cd text, tmplt_cd text, eml text, pwd text, auto_login text, upd_ts text, PRIMARY KEY (sys_cd, tmplt_cd))");
        // バージョンNo.保存
        await Mst001.updateTabelVersionNo(tabaleId);
        if ( GFunc.isDebugEnabled() ) {console.log(tabaleId+"テーブルを作成しました。", resp);}
    }
    catch(e)
    {
        console.log(GVar.sqliteErrorMsg+tabaleId+"テーブルの作成に失敗しました。："+`${e}`);
    }
}

/**
 * ログイン情報を変数mst002にセットし、dispatch()を呼ぶ
 *
 * @param sys_cd システムコード
 * @param tmplt_cd テンプレートコード
 */
export const getLoginInfo = async function(sysCd: string, tmpltCd: string)
{
    if ( GFunc.isDebugEnabled() ) { console.log("getLoginInfo()"); }

    try
    {
        const result = await GVar.db!.query("select sys_cd, tmplt_cd, eml, pwd, auto_login, upd_ts from mst002 where sys_cd = ? and tmplt_cd = ?",
            [sysCd, tmpltCd]);
        GVar.setAutoLogin(false);
        if ( result.values!.length > 0 )
        {
            // DTOにデータをセット
            GVar.setMst002(new Mst002DTO(
                result.values[0].sys_cd,
                result.values[0].tmplt_cd,
                result.values[0].eml,
                result.values[0].pwd,
                result.values[0].auto_login,
                result.values[0].upd_ts
            ));
            // オートログインをセット
            if ( GVar.mst002!.auto_login == "1" ) { GVar.setAutoLogin(true); }
        }
    }
    catch(e)
    {
        console.log(GVar.sqliteErrorMsg+`${e}`);
        GVar.setAutoLogin(false);
        return;
    }
}

/**
 * ログイン情報を保存する
 *
 * @param mst002 Mst002DTOオブジェクト
 */
export const saveLoginInfo = async function(mst002: any)
{
    if ( GFunc.isDebugEnabled() ) { console.log("saveLoginInfo()"); }
    try
    {
        // DELETE,INSERTを行う
        let result = await GVar.db!.run("delete from mst002 where sys_cd = ? and tmplt_cd = ?", [mst002.sys_cd, mst002.tmplt_cd]);
        result = await GVar.db!.run("insert into mst002 (sys_cd, tmplt_cd, eml, pwd, auto_login, upd_ts) VALUES (?,?,?,?,?,?)",
            [mst002.sys_cd, mst002.tmplt_cd, mst002.eml, mst002.pwd, mst002.auto_login, Tools.getCurrentYyyymmddhhmmss()]);
    }
    catch(e)
    {
        console.log(GVar.sqliteErrorMsg+`${e}`);
    }
}